export function nameFormatting(...names: (string | undefined)[]) {
	const formattedNames = names
		.filter((name) => name !== undefined)
		.map((name) => {
			const words = (name || '').split(' ');
			const formattedWords = words.map((word) =>
				word
					.split(/([-'])/)
					.map((part) => {
						if (part === '-' || part === "'") {
							return part;
						}

						return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
					})
					.join('')
			);
			return formattedWords.join(' ');
		});
	return formattedNames.join(' ');
}

export function extractCountryNames(countryInfo: string) {
	const countryNames = countryInfo.split('|').map((item) => {
		const parts = item.trim().split(/\s+/);
		if (parts.length > 1) {
			parts.shift();
		}
		return parts.join(' ');
	});

	return countryNames.join(' | ');
}

export function formatCity(city: string) {
	const words = city.split(' ');

	const formattedWords = words.map((word) => {
		if (word.length <= 2) {
			return word.toUpperCase();
		}
		return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
	});

	return formattedWords.join(' ');
}

export interface FormatSubjectNameOptions {
	showIco?: boolean;
}

export const formatSubjectName = (
	osoba:
		| { nazev?: string; ico?: number }
		| { jmeno?: string; prijmeni?: string }
		| undefined,
	options: FormatSubjectNameOptions = { showIco: true }
) => {
	if (!osoba) {
		return '-';
	}
	if ('nazev' in osoba && 'ico' in osoba) {
		if (options.showIco && osoba.ico) {
			return `${osoba.nazev} (${osoba.ico?.toString()})`;
		} else {
			return osoba.nazev || '-';
		}
	} else if ('jmeno' in osoba && 'prijmeni' in osoba) {
		return nameFormatting(osoba.jmeno, osoba.prijmeni);
	}
	return '-';
};
